import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const brand = {
  logo: "/brand/logo_transparent.png",
  icon: "/brand/logo_icon.jpg",
  mascot: "/brand/mascot.jpg",
  texture: "/brand/paint_texture.jpg",
  instagram: "https://www.instagram.com/paint.with.tay/",
};
